import { useEffect } from 'react';
import { useAuthStore } from './auth/authStore';
import { PairingScreen } from './screens/PairingScreen';
import { MapScreen } from './screens/MapScreen';

export function App() {
  const hasTokens = useAuthStore((s) => s.hasTokens);
  const hydrate = useAuthStore((s) => s.hydrate);

  useEffect(() => {
    hydrate();
  }, [hydrate]);

  return hasTokens ? <MapScreen /> : <PairingScreen />;
}
